import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Collection } from '../../models/collection.interface';

@Injectable({
  providedIn: 'root'
})
export class CollectionService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/collections`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getCollections(category?: string, subCategory?: string): Observable<Collection[]> {
    const params: string[] = [];
    if (category && category !== 'all') params.push(`category=${encodeURIComponent(category)}`);
    if (subCategory && subCategory !== 'all') params.push(`subCategory=${encodeURIComponent(subCategory)}`);
    const url = params.length > 0 ? `${this.apiUrl}?${params.join('&')}` : this.apiUrl;
    return this.http.get<Collection[]>(url);
  }

  getCollectionById(id: string): Observable<Collection> {
    return this.http.get<Collection>(`${this.apiUrl}/${id}`);
  }

  createCollection(collection: Partial<Collection>): Observable<Collection> {
    return this.http.post<Collection>(this.apiUrl, collection);
  }

  updateCollection(id: string, collection: Partial<Collection>): Observable<Collection> {
    return this.http.put<Collection>(`${this.apiUrl}/${id}`, collection);
  }

  deleteCollection(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}
